// @flow
import {CLEAR_NOTIFICATIONS, SHOW_NOTIFICATION, GET_SETTINGS_ERROR, 
    POST_SETTINGS_ERROR, NOTIFICATION_TYPE, POST_SESSIONS_PRIVACY_ERROR}
    from '../actions/constants';

import type {Notification} from './types';

const notification = (state: ?Notification = null, action: any): ?Notification => {
    if (action.type === CLEAR_NOTIFICATIONS) {
        return null;
    } else if (action.type === SHOW_NOTIFICATION) {
        return {
            type: action.notificationType,
            msg: 'common:save_success',
            fallbackMsg: 'Settings saved'
        };
    } else if (action.type === GET_SETTINGS_ERROR || action.type === POST_SETTINGS_ERROR) {
        return {
            type: NOTIFICATION_TYPE.ERROR,
            msg: 'settings:flash.error.unknownError',
            fallbackMsg: 'Unexpected error occurred'
        };
    } else if (action.type === POST_SESSIONS_PRIVACY_ERROR) {
        return {
            type: NOTIFICATION_TYPE.ERROR,
            msg: 'common:error.title.something_went_wrong',
            fallbackMsg: 'Something went wrong'
        };
    }
    return state;
};

export default notification;



// WEBPACK FOOTER //
// ./src/UserSettings/reducers/notification.js